export default "__VITE_ASSET__BbWa9cq1__"